<video style="width: 0; height: 0" #videoElement [src]="src" controls></video>
{{ duration | number: '1.2-2' | replaceText: {',' : ':', "." : ":"} }}